import { useEffect, useState } from "react";
import { E_immatriculation } from "../../../../constants/constant";
import axios from "axios";
import Label from "../../../../components/title/label";
import Checkbox from "../../../../components/button/Checkbox";
import { Link } from "react-router-dom";
import { RiArrowGoBackFill } from "react-icons/ri";
import BackButton from "../../../../components/button/BackButton";
import { Navbar } from "../../../../components/navbar/Navbar";

function AutreContribuable() {
  const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
  const [ContribuableData] = useState(JSON.parse(selectedData));
  const [Autre, setAutre] = useState([]);
  const [AllAutre, setAllAutre] = useState([]); 
  const filterId = ContribuableData.id;

  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${E_immatriculation}/autre`)
      .then((response) => setAllAutre(response.data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const filteredData = AllAutre.find((item) => item.id_contribuable === filterId);
    setAutre(filteredData || {});  // Assure que Autre est toujours un objet
  }, [AllAutre, filterId]);

  console.log("Données Autre :", Autre);

  // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
      <div className="text-white">Autre</div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
  const handleCheckboxChange = (field) => {
    setAutre((prev) => ({
      ...prev,
      [field]: !prev[field], // Inverser la valeur actuelle
    }));
  };
  
  return (
    <div className="w-full bg-[#212122] h-screen">
      <Navbar content={contentNavbar} />
      <main className="mt-24">
        <div className="p-4">
          <div className="flex justify-center w-full h-full">
            <div className="flex flex-col w-[500px]">
              
              {/* M'envoyer par e-mail les informations saisies */}
              <div className="flex justify-between mt-6">
                <Label text="M'envoyer par e-mail les informations saisies" />
                <div className="flex justify-between w-[300px]">
  <Checkbox
  label="Oui"
  checked={Autre?.information_mail === true}
  onChange={() => handleCheckboxChange("information_mail")}
/>
<Checkbox
  label="Non"
  checked={Autre?.information_mail === false}
  onChange={() => handleCheckboxChange("information_mail")}
/>

                </div>
              </div>

              {/* Votre exercice dépasse-t-il 12 mois ? */}
              <div className="flex justify-between mt-6">
                <Label text="Votre exercice dépasse-t-il 12 mois ?" />
                <div className="flex justify-between w-[300px]">
                  <Checkbox onChange={window} label="Oui (18 mois)" checked={Autre?.depassement_12_mois === true} />
                  <Checkbox onChange={window} label="Non (12 mois)" checked={Autre?.depassement_12_mois === false} />
                </div>
              </div>

              {/* Certification */}
              <div className="flex justify-between mt-6">
                <Label text="Je certifie que ces renseignements sont complets et exacts" />
                <Checkbox onChange={window} checked={!!Autre?.certification} />

              </div>
            </div>
          </div>

          {/* Bouton Fermer */}
          <div className="flex justify-center mt-6">
            <Link to={`/SituationGeographiqueIm`} className="border-[2px] text-white ml-4 p-2 border-white rounded hover:bg-black/70 hover:text-white flex flex-row">
              <RiArrowGoBackFill className="text-2xl mr-2" />Fermer
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AutreContribuable;
